var React = require('react');

function HouseBlockListsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 2h-4v6h4V2zm16 0h-4v6h4V2zM22 2h4v6h-4V2zm-4 38h-4v6h4v-6zm16 0h-4v6h4v-6zm-12 6v-6h4v6h-4zM2 18v-4h6v4H2zm0 8v-4h6v4H2zm0 4v4h6v-4H2zm38-16v4h6v-4h-6zm6 8h-6v4h6v-4zm-6 12v-4h6v4h-6zM10 10h28v28H10V10zm14 21a7 7 0 0 0 6.159-10.33l-9.49 9.489c.991.536 2.125.841 3.331.841zm3.33-13.159-9.489 9.49a7 7 0 0 1 9.489-9.489zM24 35c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z","fill":"#8D6CFF"}));
}

HouseBlockListsIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = HouseBlockListsIcon;

HouseBlockListsIcon.default = HouseBlockListsIcon;
